import { EventEmitter } from './util/event-emitter';
import { FrameType, FrameCacheMode } from './types';
import { log, FACILITY as LOG_FACILITY } from './util/log';
var LOG = LOG_FACILITY.PLAYBACK;
var TIMER_INTERVAL = 15;
export function emitModelState(handler, timestamp, index, state) {
    if (handler && state) {
        handler({
            type: FrameType.ModelStateFrame,
            version: 1,
            timestamp: timestamp,
            index: index,
            state: state,
        });
    }
}
var Playback = (function () {
    function Playback(frameCache) {
        var _this = this;
        this.load = function (timings) {
            _this.timings = timings;
            if (_this.timerContext) {
                clearInterval(_this.timerContext);
            }
            _this.timerContext = setInterval(_this.playbackHandler, TIMER_INTERVAL);
        };
        this.initialize = function () {
            log.info(LOG, 'initialize');
            if (_this.timerContext) {
                clearInterval(_this.timerContext);
                _this.timerContext = 0;
                if (_this.completionHandler) {
                    _this.completionHandler();
                }
            }
            _this.timings = [];
            _this.speed = 1;
            _this.paused = true;
        };
        this.play = function () {
            log.info(LOG, '------ Play -----');
            _this.paused = false;
        };
        this.pause = function () {
            _this.paused = true;
        };
        this.stepForward = function () {
            _this.paused = true;
            _this.playOne = true;
            _this.timingsIndex++;
            if (_this.timingsIndex >= _this.timings.length) {
                _this.timingsIndex = 0;
            }
            _this.playbackHandler();
        };
        this.stepBack = function () {
            _this.paused = true;
            _this.playOne = true;
            _this.timingsIndex--;
            if (_this.timingsIndex < 0) {
                _this.timingsIndex = _this.timings.length - 1;
            }
        };
        this.scrubToIndex = function (index) {
            if (index < 0 || index > _this.timings.length) {
                log.error(LOG, 'scrubToIndex out of range');
                index = 0;
            }
            _this.timingsIndex = index;
            _this.tsRecAt = _this.timings[index];
            _this.tsRecAtLast = _this.timings[index];
            if (index === 0) {
                _this.tsSysStart = Date.now();
                _this.tsSysLast = _this.tsSysStart;
            }
        };
        this.loop = function (doit) {
            _this.looping = doit;
        };
        this.playbackHandler = function () {
            if (_this.frameCache.mode !== FrameCacheMode.Playback) {
                return;
            }
            var now = Date.now();
            var deltaLast = now - _this.tsSysLast;
            if (_this.paused && !_this.playOne) {
                _this.tsSysLast = now;
                return;
            }
            if (_this.playOne) {
                deltaLast = 0;
            }
            _this.tsRecAt = _this.tsRecAtLast + _this.speed * deltaLast;
            if (_this.tsRecAt >= _this.frameCache.endTime) {
                if (_this.looping) {
                    _this.scrubToIndex(0);
                }
            }
            var modelState = null;
            var analyticTuple = null;
            if (_this.playOne) {
                _this.playOne = false;
                analyticTuple = _this.frameCache.analyticTuples.get(_this.timings[_this.timingsIndex]);
                modelState = _this.frameCache.modelStates.get(_this.timings[_this.timingsIndex]);
            }
            else {
                while (_this.timingsIndex < _this.timings.length &&
                    _this.timings[_this.timingsIndex] <= _this.tsRecAt) {
                    analyticTuple = _this.frameCache.analyticTuples.get(_this.timings[_this.timingsIndex]);
                    modelState = _this.frameCache.modelStates.get(_this.timings[_this.timingsIndex]);
                    _this.timingsIndex++;
                }
            }
            if (modelState) {
                EventEmitter.emitState(modelState);
            }
            if (analyticTuple) {
                EventEmitter.emitAnalytics(analyticTuple);
            }
            _this.tsSysLast = now;
            _this.tsRecAtLast = _this.tsRecAt;
        };
        this.frameCache = frameCache;
        this.speed = 0;
        this.timerContext = 0;
        this.looping = true;
        this.paused = true;
        this.tsSysStart = 0;
        this.tsSysLast = 0;
        this.tsRecAt = 0;
        this.tsRecAtLast = 0;
        this.timingsIndex = 0;
        this.completionHandler = 0;
        this.timings = [];
        this.playOne = false;
    }
    Playback.prototype.getCurrentPlaybackIndex = function () {
        return this.timingsIndex;
    };
    return Playback;
}());
export { Playback };
//# sourceMappingURL=playback.js.map